import { render, staticRenderFns } from "./send-chapter.vue?vue&type=template&id=d6f920ae&scoped=true&"
import script from "./send-chapter.vue?vue&type=script&lang=js&"
export * from "./send-chapter.vue?vue&type=script&lang=js&"
import style0 from "./send-chapter.vue?vue&type=style&index=0&id=d6f920ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f920ae",
  null
  
)

export default component.exports